export const AUTH_API_URL = process.env.REACT_APP_API_URL;
export const AUTH_URL = `${document.location.protocol}//${document.location.host}/`;
export const APP_API_URL = process.env.REACT_APP_API_URL;
export const AUTH_SIGN_IN_URL = `${AUTH_URL}sign-in`;
